class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const wasOpen = this.classList.contains('active');
    const scrollTop = this.querySelector('.bj-cart-scroll')?.scrollTop || 0;
    const focused = document.activeElement;
    const focusedInput = focused?.closest('.cart-item')?.querySelector('.quantity__input');
    const focusKey = focusedInput?.dataset.key;
    const focusVariant = focusedInput?.dataset.quantityVariantId;
    const focusName = focused?.getAttribute('name');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      if (!parsedState.sections[section.id]) return;
      if (section.id === 'cart-drawer') {
        const doc = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html');
        const fresh = doc.querySelector('.drawer__inner');
        const inner = this.querySelector('.drawer__inner');
        if (!fresh || !inner) return;
        const empty = doc.querySelector('cart-drawer')?.classList.contains('is-empty');
        inner.innerHTML = fresh.innerHTML;
        this.classList.toggle('is-empty', !!empty);
        const scroll = this.querySelector('.bj-cart-scroll');
        if (scroll) scroll.scrollTop = scrollTop;
        if (wasOpen && empty && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          inner.querySelector('.drawer__inner-empty')?.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 160 });
        }
      } else {
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });
    // An update is not an open action: keep the shell, scroll and focus stable.
    if (wasOpen) {
      const inputs = [...this.querySelectorAll('.quantity__input')];
      const input = inputs.find(input => input.dataset.key === focusKey) || inputs.find(input => input.dataset.quantityVariantId === focusVariant);
      const target = input?.closest('.cart-item')?.querySelector(`[name="${CSS.escape(focusName || '')}"]`);
      const fallback = this.querySelector('.drawer__inner-empty a') || this.querySelector('.drawer__close');
      if (this.contains(focused) || !focused?.isConnected) {
        trapFocus(this.querySelector('.drawer__inner'), target || fallback);
      }
      const scroll = this.querySelector('.bj-cart-scroll');
      if (scroll) scroll.scrollTop = scrollTop;
    } else if (parsedState.open !== false) {
      this.open();
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
